import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row, Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import TableLayout from "../../../components/TableLayout";
import { getUsers, updateUser } from "../../../store/users/actions";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import logoicon from "../../../Assets/images/usericon.png";
import { toast } from "react-toastify";
import FadeLoader from "react-spinners/FadeLoader";
import { DownloadUserList } from "../../../store/downloadcsv/actions";
const ManageUsers = () => {
  const dispatch = useDispatch();
  const [pageSize, setPageSize] = useState(10);
  const navigate = useNavigate();
  const [isDownloading, setIsDownloading] = useState(false);
  const { users, loading, totalCount } = useSelector((state) => state.User);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [filter, setFilter] = useState({
    // status: "active",
    // orderBy: "createdAt",
    page: 1,
    // order: -1,
    limit: pageSize,
    search: "",
  });
  const fetchData = async () => {
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          toast.success(res.message);
        }
      };
      dispatch(getUsers({ data: filter, callback }));
    } catch (error) {
      console.error(error, "<===err");
    }
  };
  useEffect(() => {
    fetchData();
  }, [filter]);
  const handleUserStatus = (item) => {
    try {
      const newStatus = item?.status === "active" ? "blocked" : "active";
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          fetchData();
          toast.success("Status Changed");
        }
      };
      dispatch(
        updateUser({
          data: { _id: item._id, status: newStatus },
          callback,
        }),
      );
    } catch (error) {
      console.error(error, "<=== Error occurred");
    }
  };
  const handleViewUser = (id) => {
    navigate(`/user/${id}`);
  };
  const handlePageChange = (page) => {
    setFilter((prev) => ({ ...prev, page: page.selected + 1 }));
  };
  const handleFilter = () => {
    setFilter((prev) => ({
      ...prev,
      status: selectedStatus,
    }));
  };
  const clearFilter = () => {
    setFilter((prev) => ({ ...prev, page: 1, limit: pageSize }));
    setSelectedStatus("");
  };

  const handleDownload = () => {
    try {
      setIsDownloading(true);
      const callback = (err, res) => {
        setIsDownloading(false);
        if (err) {
          toast.error(err);
        } else {
          const url = res.data;
          if (url) {
            window.open(url, "_blank");
            toast.success("Download successful!");
          } else {
            toast.error("Download URL not found.");
          }
        }
      };
      dispatch(DownloadUserList({ data: { export: "csv" }, callback }));
    } catch (error) {
      setIsDownloading(false);
    }
  };

  const column = [
    {
      head: "Sr No",
      accessor: "",
      isComponent: true,
      component: (item, ind) => (
        <span className="text-capitalize cursor-pointer">
          {(filter.page - 1) * pageSize + (ind + 1)}
        </span>
      ),
    },
    {
      head: "Email Address ",
      accessor: "email",
    },
    {
      head: "Created At",
      accessor: "createdAt",
      isComponent: true,
      component: (item, ind) => (
        <span className="text">
          {moment(item?.createdAt).format("YYYY-MM-DD")}
        </span>
      ),
    },
    {
      head: "Status",
      accessor: "Status",
      isComponent: true,
      component: (item, ind) => (
        <p
          className={`${
            item.status == "active"
              ? "greenStatus"
              : item.status == "blocked"
                ? "redStatus"
                : ""
          } status text-capitalize m-0 d-flex justify-content-center align-item-center rounded-pill px-3 py-1`}
        >
          {item.status}
        </p>
      ),
    },
    // {
    //   head: "Actions",
    //   accessor: "",
    //   isComponent: true,
    //   component: (item) => (
    //     <div className="ActnBtn d-flex align-items-center  gap-10">
    //       <Form.Check
    //         className="fs-5"
    //         style={{ cursor: "pointer" }}
    //         type="switch"
    //         id={`custom-switch-${item._id}`}
    //         checked={item.status === "active"}
    //         onClick={() => handleUserStatus(item)}
    //       />
    //       <Button
    //         onClick={() => handleViewUser(item._id)}
    //         className="p-0"
    //         variant="transparent"
    //         type="button"
    //       >
    //         <svg
    //           width="24"
    //           height="24"
    //           viewBox="0 0 24 24"
    //           fill="none"
    //           xmlns="http://www.w3.org/2000/svg"
    //         >
    //           <path
    //             d="M12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9ZM12 17C10.6739 17 9.40215 16.4732 8.46447 15.5355C7.52678 14.5979 7 13.3261 7 12C7 10.6739 7.52678 9.40215 8.46447 8.46447C9.40215 7.52678 10.6739 7 12 7C13.3261 7 14.5979 7.52678 15.5355 8.46447C16.4732 9.40215 17 10.6739 17 12C17 13.3261 16.4732 14.5979 15.5355 15.5355C14.5979 16.4732 13.3261 17 12 17ZM12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5Z"
    //             fill="#6F6F6F"
    //           />
    //         </svg>
    //       </Button>
    //     </div>
    //   ),
    // },
  ];
  return (
    <>
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      <section className="ManageTeacher position-relative">
        <Container>
          <div className="pb-2 cardCstm">
            <Row className="px-3 py-2 bg-white align-items-center">
              <Col lg="12" className="mb-3">
                <div className="d-flex align-items-center justify-content-between">
                  <h5 className="mb-0 fw-sbold text-capitalize">
                    Users Listing
                  </h5>
                  {/* <Link
                    to="/user/add"
                    className="btn btn-primary d-flex align-items-center justify-content-center commonBtn"
                  >
                    + Add User
                  </Link> */}
                </div>
              </Col>
              <Col md={4} className="mb-3">
                <Form.Control
                  type="text"
                  name="search"
                  value={filter.search || ""}
                  placeholder="Search using name or email"
                  onChange={(e) =>
                    setFilter((prev) => ({ ...prev, search: e.target.value }))
                  }
                />
              </Col>
              <Col md={3} className="mb-3">
                <Form.Select
                  className="p-2"
                  value={selectedStatus}
                  onChange={(e) => setSelectedStatus(e.target.value)}
                >
                  <option value="">Select Status</option>
                  <option value="active">Active</option>
                  <option value="blocked">Blocked</option>
                </Form.Select>
              </Col>
              <Col md={3} className="mb-3">
                <div className="d-flex gap-2">
                  <Button onClick={handleFilter} variant="primary">
                    Filter
                  </Button>
                  <Button onClick={clearFilter} variant="secondary">
                    Clear
                  </Button>
                </div>
              </Col>
              {/* <Col md={2} className="mb-3 text-md-end">
                <Button
                  onClick={handleDownload}
                  variant="info"
                  className="bg-black text-white"
                  disabled={isDownloading}
                >
                  {isDownloading ? (
                    <span>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                      Exporting...
                    </span>
                  ) : (
                    "Export CSV"
                  )}
                </Button>
              </Col> */}
            </Row>
          </div>
          <Row>
            {!loading && (
              <Col lg="12" className=" mx-0">
                <div className="cardCstm p-3 rounded bg-white">
                  {!loading && users?.length > 0 ? (
                    <>
                      <TableLayout
                        data={users}
                        column={column}
                        totalCount={totalCount}
                        limit={filter.limit}
                        loading={loading}
                        handlePageChange={handlePageChange}
                        page={filter.page}
                        status={"status"}
                      />
                    </>
                  ) : (
                    <div className="d-flex justify-content-center">
                      <p>No Data Found</p>
                    </div>
                  )}
                </div>
              </Col>
            )}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ManageUsers;
